const routes = [
  {
    name: 'home',
    path: '/',
  },
  {
    name: 'login',
    path: '/login',
  },
  {
    name: 'project',
    path: '/project/:id',
  },
  {
    name: 'help',
    path: '/help',
  },
  {
    name: 'notfound',
    path: '/notfound',
  },
]


export default routes